import { generatePath, Navigate } from "react-router";

import type { LangCode } from "@/lib/gql/__generated__/graphql";

import { PATHS } from "@/routes/paths";

import * as Repository from "../repository";
import { MarketingVoucherEditExistingPresenter } from "./presenter";

type Props = {
	hotelID: string;
	voucherID: string;

	activeLangCode?: LangCode;
	navigator?: {
		default: string;
		i18n: (langCode: LangCode) => string;
	};
};
export const MarketingVoucherEditExistingContainer = ({ hotelID, voucherID, navigator, activeLangCode }: Props) => {
	const queryData = Repository.Query.UseCase.useVoucherQuery({ hotelID, voucherID });

	if (!queryData) {
		return <Navigate to={generatePath(PATHS.HOTEL.MARKETING.VOUCHER.TOP, { hotelID })} />;
	}

	return (
		<MarketingVoucherEditExistingPresenter
			hotelID={hotelID}
			voucherID={voucherID}
			queryData={queryData}
			navigator={navigator}
			activeLangCode={activeLangCode}
		/>
	);
};

MarketingVoucherEditExistingContainer.displayName = "MarketingVoucherEditExistingContainer";
